import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { notificationBubbleAnimation } from '../../../digital/services/notification-bubble-animation';
import { DigitalAccaBoostModule } from '../../acca-boost/digital-acca-boost.module';
import { ACCA_BOOST_LAYOUT_PROVIDER } from '../../acca-boost/model';
import { AccaBoostLayoutService } from '../../acca-boost/services/digital/acca-boost-layout.service';
import { AccaBoostNotificationSyncService } from '../../acca-boost/services/digital/acca-boost-notification-sync.service';
import { SharedAccaBoostModule } from '../../acca-boost/shared-acca-boost.module';
import { QuickBetAccaBoostBaseComponent } from './quick-bet-acca-boost-base.component';

@Component({
    selector: 'bs-quick-bet-acca-boost-ladder',
    templateUrl: './quick-bet-acca-boost-ladder.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-acca-boost.component.scss'],
    animations: [notificationBubbleAnimation],
    providers: [AccaBoostNotificationSyncService, { provide: ACCA_BOOST_LAYOUT_PROVIDER, useClass: AccaBoostLayoutService }],
    imports: [DigitalAccaBoostModule, SharedAccaBoostModule, CommonModule],
})
export class QuickBetAccaBoostLadderComponent extends QuickBetAccaBoostBaseComponent {
    constructor(accaBoostNotificationSyncService: AccaBoostNotificationSyncService) {
        super(accaBoostNotificationSyncService);
    }
}
